var onloadCallback = function() {
	grecaptcha.render('g-recaptcha', {
		'sitekey' : '6LdWSiYTAAAAAMuYxskR32vbdAa8qTk_qkPGLrF6'
	});
};
(function (w){
	var doc = w.document;
	var Form = function Form(element) {
		this.errors = this.errors || {};
		this.regex = this.regex || {};
		this.fields = {};
	};
	Form.prototype.regex = {
		base: /^(([a-zA-Z\-])|([a-zA-Z\-]+[\.][a-zA-Z\-]))*$/,
		name: /^[a-zA-Z\- ]*$/,
		skype: /^[a-zA-Z0-9-_.,:@]{3,30}$/,
		email: /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/,
		website: /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/,
		phone: /^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/,
		volume: /^[-+]?[0-9]*\.?[0-9]+$/,
	};
	Form.prototype.errors = {
		server: 'Server error',
		captcha: 'Captcha validation failed',
		email: 'Invalid email address. Valid e-mail can contain only latin letters, numbers, \'@\' and \'.\'',
		name: 'First name seems invalid.',
		skype: 'Skype seems invalid.',
		phone: 'Phone number seems invalid.',
		emailAlready: 'This email address is already successfully subscribed',
		empty: 'Please fill the required field.',
		invalid: 'Field invalid',
		valid: 'Field valid'
	};
	Form.prototype.disabled = function disabled(state) {
		this.sendButton.disabled = state;
		this.fields.name.disabled = state;
		this.fields.website.disabled = state;
		this.fields.skype.disabled = state;
		this.fields.email.disabled = state;
		this.fields.phone.disabled = state;
		this.fields.volume.disabled = state;
		this.fields.geography.disabled = state;
		this.fields.message.disabled = state;
	};
	Form.prototype.reset = function reset() {
		var self = this;
		self.form.reset();
		self.removeIcons();
		setTimeout(function () {
			self.disabled(false);
		}, 600);
	};
	Form.prototype.createIcon = function createIcon(type) {
		var icon = doc.createElement('span');
			icon.className = 'icon is-small';
			icon.innerHTML = (type === 'error') ? '<i class="mi mi-error"></i>' : '<i class="mi mi-success"></i>';
		return icon;
	};
	Form.prototype.removeIcons = function removeIcons() {
		var inputs = this.form.querySelectorAll('.js-send-data'),
			captchaParent = this.recaptcha.parentNode,
			captchaIcon = captchaParent.querySelector('.icon');

		for (var i = inputs.length - 1; i >= 0; i--) {
			var parent = inputs[i].parentNode,
				icon = parent.querySelector('.icon');
			if (icon) {
				this.removeChild(parent, [icon]);
			}
		}
		this.removeChild(captchaParent, [captchaIcon]);
	};
	Form.prototype.createHelp = function createHelp(type, message) {
		var help = doc.createElement('span');
			help.className = (type === 'error') ? 'help is-danger' : 'help is-success';
			help.innerHTML = message;
		return help;
	};
	Form.prototype.removeChild = function removeChild(parent, element) {
		for (var i = element.length - 1; i >= 0; i--) {
			parent.removeChild(element[i]);
		}
	};
	Form.prototype.addChild = function addChild(parent, element) {
		for (var i = element.length - 1; i >= 0; i--) {
			parent.appendChild(element[i]);
		}
	};
	Form.prototype.checkElement = function checkElement(icon, help) {
		return (!icon && !help);
	};
	Form.prototype.setError = function setError(selector, message, show) {
		var parent = selector.parentNode,
			icon = parent.querySelector('.icon'),
			help = parent.querySelector('.help');

		if (show === true) {
			selector.classList.add('is-danger');
			if (this.checkElement(icon, help)) {
				this.addChild(parent, [this.createHelp('error', message), this.createIcon('error')]);
			} else {
				selector.classList.remove('is-success');
				if (!help) {
					this.removeChild(parent, [icon]);
				} else {
					this.removeChild(parent, [icon, help]);
				}
				this.addChild(parent, [this.createHelp('error', message), this.createIcon('error')]);
			}
		} else {
			selector.classList.remove('is-danger');

			if (this.checkElement(icon, help)) {
				this.addChild(parent, [this.createIcon('success')]);
			} else {
				if (!help) {
					this.removeChild(parent, [icon]);
				} else {
					this.removeChild(parent, [icon, help]);
				}
				this.addChild(parent, [this.createIcon('success')]);
			}
		}
	};
	Form.prototype.parseServerError = function parseServerError(code) {
		switch (code) {
			case '1':
				swal('Error!', 'Server error', 'error');
				break;
			case '100':
				this.setError(this.recaptcha, this.errors.captcha, true);
				grecaptcha.reset();
				break;
			case '101':
				this.setError(this.fields.email, this.errors.email, true);
				grecaptcha.reset();
				break;
			case '102':
				this.setError(this.fields.name, this.errors.name, true);
				grecaptcha.reset();
				break;
			case '104':
				this.setError(this.fields.skype, this.errors.skype, true);
				grecaptcha.reset();
				break;
			case '105':
				this.setError(this.fields.email, this.errors.emailAlready, true);
				grecaptcha.reset();
				break;
			case '106':
				this.setError(this.fields.phone, this.errors.phone, true);
				grecaptcha.reset();
				break;
			default:
				swal('Error!', 'Server error', 'error');
		}
	};

	var formId = guid();

	function guid() {
		function s4() {
			return Math.floor((1 + Math.random()) * 0x10000)
				.toString(16)
				.substring(1);
		}
		if (localStorage.getItem('formId')) {
			return localStorage.getItem('formId');
		} else {
			var id = s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
			localStorage.setItem('formId', id);
			return id;
		}
	}

	// Form.prototype.checkField = function () {
	// 	return '';
	// };
	Form.prototype.validate = function validate(event) {
		event.preventDefault();
		var valid = 1;
		this.form = event.target;
		this.fields.name = this.form.name;
		this.fields.website = this.form.website;
		this.fields.email = this.form.email;
		this.fields.skype = this.form.skype;
		this.fields.phone = this.form.phone;
		this.fields.volume = this.form.volume;
		this.fields.geography = this.form.geography;
		this.fields.message = this.form.message;
		this.sendButton = this.form.sendButton;
		this.recaptcha = this.form.querySelector('#g-recaptcha');
		this.response = grecaptcha.getResponse();

		// for(var field in this.fields) {
		// 	if (this.fields.hasOwnProperty(field)) {
		// 		console.log('field', this.fields[field].name, this.fields[field].value);
		// 	}
		// }

		if (this.fields.name.value === '') {
			valid = 0;
			this.setError(this.fields.name, this.errors.empty, true);
		} else if (this.fields.name.value !== '' && !this.regex.name.test(this.fields.name.value)) {
			valid = 0;
			this.setError(this.fields.name, this.errors.invalid, true);
		} else {
			this.setError(this.fields.name, '', false);
		}

		if (this.fields.email.value === '') {
			valid = 0;
			this.setError(this.fields.email, this.errors.empty, true);
		} else if (this.fields.email.value !== '' && !this.regex.email.test(this.fields.email.value)) {
			valid = 0;
			this.setError(this.fields.email, this.errors.email, true);
		} else {
			this.setError(this.fields.email, '', false);
		}

		if (this.fields.website.value === '') {
			valid = 0;
			this.setError(this.fields.website, this.errors.empty, true);
		} else if (this.fields.website.value !== '' && !this.regex.website.test(this.fields.website.value)) {
			valid = 0;
			this.setError(this.fields.website, this.errors.invalid, true);
		} else {
			this.setError(this.fields.website, '', false);
		}

		if (this.fields.skype.value !== '' && !this.regex.skype.test(this.fields.skype.value)) {
			valid = 0;
			this.setError(this.fields.skype, this.errors.skype, true);
		} else {
			this.setError(this.fields.skype, '', false);
		}

		if (this.fields.phone.value !== '' && !this.regex.phone.test(this.fields.phone.value)) {
			valid = 0;
			this.setError(this.fields.phone, this.errors.phone, true);
		} else {
			this.setError(this.fields.phone, '', false);
		}

		if (this.fields.volume.value !== '' && !this.regex.volume.test(this.fields.volume.value)) {
			valid = 0;
			this.setError(this.fields.volume, this.errors.invalid, true);
		} else {
			this.setError(this.fields.volume, '', false);
		}

		if (this.fields.geography.value !== '' && !this.regex.name.test(this.fields.geography.value)) {
			valid = 0;
			this.setError(this.fields.geography, this.errors.invalid, true);
		} else {
			this.setError(this.fields.geography, '', false);
		}

		if (this.response.length === 0) {
			valid = 0;
			this.setError(this.recaptcha, this.errors.empty, true);
		} else {
			this.setError(this.recaptcha, '', false);
		}

		return !valid ? false : this.send();
	};
	Form.prototype.conversion = function conversion() {
		/* Conversion Tracking Start */
		var google_conversion_id = 860472844,
			google_conversion_language = "en",
			google_conversion_format = "3",
			google_conversion_color = "ffffff",
			google_conversion_label = "0ocWCLTawG4QjIynmgM",
			google_remarketing_only = false;

		var script = doc.createElement('script');
			script.src = '//www.googleadservices.com/pagead/conversion.js';

		var image = new Image(1, 1);
			image.src = "//www.googleadservices.com/pagead/conversion/860472844/?label=0ocWCLTawG4QjIynmgM&amp;guid=ON&amp;script=0";

		doc.head.appendChild(script);
		doc.body.appendChild(image);
		/* Conversion Tracking End */
	};

	const sendToAnalytics = (isError = false) => {
		const type = isError ? 'error' : 'success';
		w?.ga('create', ANALYTICS_ID, 'auto');
		w?.ga('send', {
			hitType: 'event',
			eventCategory: `${type}-form-send`,
			eventAction: `${type}-form-send-maxpay`,
			eventLabel: `${type}-form-send-start`,
		});
	};

	Form.prototype.send = function send() {
		var self = this,
			url = '/contact',
			formData = new FormData(),
			xhr = new XMLHttpRequest(),
			inputs = this.form.querySelectorAll('.js-send-data');
			checkbox = this.form.querySelector('.js-checkbox');

		formData.append('landingDomain', 'start.maxpay.com');
		formData.append('g-recaptcha-response', this.response);
		formData.append('form-id', formId);
		formData.append('contact[checkbox]', checkbox.checked);

		if (doc.referrer !== "") formData.append('referrer', doc.referrer);
		if (doc.location.search !== "") formData.append('utm', doc.location.search);

		for (var i = inputs.length - 1; i >= 0; i--) {
			if (inputs[i].value !== '') {
				formData.append(inputs[i].name, inputs[i].value);
			}
		}

		this.disabled(true);

		xhr.open('POST', url, true);
		xhr.send(formData);

		xhr.onreadystatechange = function () {
			var code = xhr.getResponseHeader('Error-code');
			var message = xhr.getResponseHeader('Error-message');

			if (xhr.readyState !== 4) return;
			MaxpayAnalytics.trackForm(xhr.status === 200 ? 'success' : 'error', 'start');

			if (xhr.status !== 200 && message) {
				if (code === '1') {
					swal('Error!', message, 'error');
				}
				self.parseServerError(code);
				self.reset();
				sendToAnalytics(true);
			} else if (xhr.status !== 200) {
				var messageText = xhr.status + ' - ' + xhr.statusText;
				swal('Error!', messageText, 'error');
				grecaptcha.reset();
				self.reset();
				sendToAnalytics(true);
			} else {
				swal({
					title: 'Congratulations!',
					text: 'Your message has been successfully sent. <br> We\'ll contact you as soon possible.',
					type: 'success',
					confirmButtonColor: "#b0b0b0",
					confirmButtonText: "Close",
					closeOnConfirm: true,
					animation: "slide-from-top",
					html: true
				});
				self.conversion();
				self.disabled(true);
				fbq('track', 'CompleteRegistration');
				sendToAnalytics();
				grecaptcha.reset();
				self.reset();
			}
		};
	};

	var startNow = doc.querySelector('#contactForm');
	var allInput = startNow.querySelectorAll('input');
	var startForm = new Form();

	startNow.addEventListener('submit', function (event) {
		startForm.validate(event);
	});

	for (var i = allInput.length - 1; i >= 0; i--) {
		allInput[i].addEventListener('keyup', function (e) {
			if (this.value.match(/^[ ]+$/)) {
				this.value = '';
			}
		});
	}
})(window);
